(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initImageGallery(root) {
    if (!root) return;

    // Prevent double init
    if (root.__imageGalleryInited) return;
    root.__imageGalleryInited = true;

    const track = root.querySelector('.image-gallery-track');
    const slides = Array.from(root.querySelectorAll('.image-gallery-media'));
    const progress = root.querySelector('.progress');

    if (!track || slides.length <= 1) return;

    let index = 0;
    let timer = null;
    const AUTOPLAY_MS = 4500;

    function setActive(i) {
      slides.forEach(s => s.classList.remove('is-active'));
      if (slides[i]) slides[i].classList.add('is-active');
    }

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      setActive(index);

      if (progress) {
        progress.style.backgroundSize = '0% 100%';
        progress.style.transitionDuration = '0ms';
        requestAnimationFrame(() => {
          progress.style.transitionDuration = AUTOPLAY_MS + 'ms';
          progress.style.backgroundSize = '100% 100%';
        });
      }
    }

    function start() {
      stop();
      goTo(index);
      timer = setInterval(() => goTo(index + 1), AUTOPLAY_MS);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    start();

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
  }

  function boot() {
    document.querySelectorAll('[data-image-gallery-id]').forEach(initImageGallery);
  }

  // initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // theme editor reloads sections
  document.addEventListener('shopify:section:load', function (evt) {
    if (!evt || !evt.target) return;
    // Try to init inside the loaded section only
    const root = evt.target.querySelector('[data-image-gallery-id]');
    if (root) initImageGallery(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-callout"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initMediaCallout(root) {
    if (!root || root.dataset.mediaCalloutInit === '1') return;
    root.dataset.mediaCalloutInit = '1';

    // Start hidden state (stacked), then spread when in view
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          root.classList.add('is-visible');
          // If you only want it to animate once, stop observing after first trigger:
          obs.disconnect();
        }
      });
    }, { threshold: 0.35 });

    obs.observe(root);
  }

  // Shopify theme editor reloads sections dynamically, so we scan after load
  function scan() {
    document.querySelectorAll('.js-media-callout').forEach(initMediaCallout);
  }

  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();
})();
